import format from 'date-fns/format';
import isDate from 'date-fns/isDate';

/**
 * 时间格式化
 */
export function formatDate(date, pattern = 'yyyy-MM-dd HH:mm:ss') {
  const d = new Date(date);
  if (isDate(d)) {
    return format(d, pattern);
  } else {
    return date;
  }
}

/**
 * 只显示日期不显示时间
 */
export function formatShortDate(date, format) {
  return formatDate(date, format || 'yyyy-MM-dd');
}
